import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const fade = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] } }),
};

export default function Hero() {
  const scrollShop = () => document.querySelector("#shop")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section data-testid="hero-section" className="relative min-h-[92vh] flex items-center overflow-hidden bg-background">
      <img
        src="https://images.pexels.com/photos/918798/pexels-photo-918798.jpeg"
        alt="Stadium action"
        className="absolute inset-0 w-full h-full object-cover opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background via-background/85 to-background/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-background/50" />

      <div className="relative px-6 md:px-12 lg:px-16 max-w-5xl py-24">
        <motion.p variants={fade} initial="hidden" animate="show" custom={0} className="text-xs uppercase tracking-[0.35em] font-bold text-primary mb-6">
          Legends on your back
        </motion.p>
        <motion.h1
          variants={fade} initial="hidden" animate="show" custom={1}
          className="font-anton text-[2.75rem] sm:text-7xl md:text-8xl xl:text-9xl uppercase leading-[0.85] sm:leading-[0.82] text-white"
        >
          Wear the <span className="text-primary">jersey.</span><br />
          Own the <span className="outline-text">legacy.</span>
        </motion.h1>
        <motion.p variants={fade} initial="hidden" animate="show" custom={2} className="text-sm md:text-lg text-white/60 mt-6 md:mt-8 max-w-lg leading-relaxed">
          Famous player jerseys, blended onto premium hoodies and tees. Built for sports fans — designed to expand into every culture you love.
        </motion.p>
        <motion.div variants={fade} initial="hidden" animate="show" custom={3} className="flex flex-wrap gap-3 md:gap-4 mt-8 md:mt-10">
          <button
            data-testid="hero-shop-button"
            onClick={scrollShop}
            className="group bg-primary text-black hover:bg-white px-6 md:px-8 py-3.5 md:py-4 font-bold uppercase tracking-[0.2em] text-sm transition-colors active:scale-95 flex items-center gap-3"
          >
            Shop now
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
          <button
            data-testid="browse-designs-button"
            onClick={scrollShop}
            className="bg-transparent text-white border border-white/30 hover:bg-white hover:text-black px-6 md:px-8 py-3.5 md:py-4 font-bold uppercase tracking-[0.2em] text-sm transition-colors"
          >
            Browse Designs
          </button>
        </motion.div>
      </div>

      <div className="absolute bottom-6 right-6 hidden md:block border border-white/15 bg-black/60 backdrop-blur-md px-5 py-3">
        <p className="font-anton text-lg uppercase tracking-tight text-white">Heavyweight fleece</p>
        <p className="text-[11px] text-white/50 uppercase tracking-[0.2em]">Premium POD quality</p>
      </div>
    </section>
  );
}
